const JOTFORM_DE = 'https://form.jotform.com/232342080692351';
const JOTFORM_FR = 'https://form.jotform.com/232342080692351?language=fr';

export const jotformLinks = {
  de: JOTFORM_DE,
  fr: JOTFORM_FR,
};
